import React from 'react';
import { motion } from 'framer-motion';
import Slider from 'react-slick';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';

const fadeUp = {
	hidden: { opacity: 0, y: 16 },
	visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: 'easeOut' } },
};

const useStyles = createUseStyles({
	partners: {
		paddingTop: '4rem',
		paddingBottom: '6rem',
	},
	logo: {
		height: 60,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '1.5rem',
		fontWeight: 700,
		color: '#6c757d',
		letterSpacing: '0.05em',
		fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
		opacity: 0.75,
		transition: 'opacity 0.2s ease-in-out',
		'&:hover': {
			opacity: 1,
		},
	},
});

const partners = [
	{ id: 1, name: 'ACME CORP' },
	{ id: 2, name: 'NORTHWIND' },
	{ id: 3, name: 'CONTOSO' },
	{ id: 4, name: 'INITECH' },
	{ id: 5, name: 'UMBRELLA' },
	{ id: 6, name: 'STARK INDUSTRIES' },
	{ id: 7, name: 'WAYNE ENT.' },
	{ id: 8, name: 'CYBERDYNE' },
];

const settings = {
	dots: false,
	arrows: false,
	infinite: true,
	speed: 800,
	autoplay: true,
	autoplaySpeed: 2000,
	pauseOnHover: true,
	slidesToShow: 5,
	slidesToScroll: 1,
	cssEase: 'linear',
	responsive: [
		{
			breakpoint: 992,
			settings: { slidesToShow: 4 },
		},
		{
			breakpoint: 768,
			settings: { slidesToShow: 3 },
		},
		{
			breakpoint: 480,
			settings: { slidesToShow: 2 },
		},
	],
};

const SectionPartners = () => {
	const classes = useStyles({});
	return (
		<motion.div
			id='partners'
			className={classNames('row scroll-margin', classes.partners)}
			variants={fadeUp}
			initial='hidden'
			whileInView='visible'
			viewport={{ once: true, amount: 0.3 }}>
			<div className='col-12 fw-bold h5 text-muted mb-4 text-center text-uppercase'>
				Trusted by teams at
			</div>
			<div className='col-12'>
				{/* eslint-disable-next-line react/jsx-props-no-spreading */}
				<Slider {...settings}>
					{partners.map((p) => (
						<div key={p.id}>
							<div className={classes.logo}>{p.name}</div>
						</div>
					))}
				</Slider>
			</div>
		</motion.div>
	);
};

export default SectionPartners;
